import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { toast } from "sonner";
import { CircleNotch, Lock } from "@phosphor-icons/react";
import { useAuth } from "@/context/AuthContext";

function formatApiErrorDetail(detail) {
  if (detail == null) return "Algo salió mal. Inténtalo de nuevo.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((e) => e?.msg || JSON.stringify(e)).join(" ");
  return String(detail);
}

export default function AdminLogin() {
  const { admin, login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (admin) navigate("/admin");
  }, [admin, navigate]);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(email, password);
      toast.success("¡Bienvenido!");
      navigate("/admin");
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail) || err.message);
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center px-5 bg-background relative overflow-hidden">
      <div className="blob w-[400px] h-[400px] -top-20 -right-20" style={{ background: "hsl(298 55% 82%)" }} />
      <motion.form
        onSubmit={submit}
        initial={{ opacity: 0, y: 30 }}
        animate={{ opacity: 1, y: 0 }}
        className="relative rounded-[2.5rem] bg-white shadow-soft-lg border border-white p-10 max-w-sm w-full"
      >
        <img src="/logo.png" alt="logo" className="h-14 mx-auto mb-6" />
        <div className="flex items-center justify-center gap-2 mb-6 text-foreground/60">
          <Lock weight="duotone" size={20} />
          <h1 className="font-display font-bold text-xl text-foreground">Panel de administración</h1>
        </div>
        <div className="space-y-4">
          <input
            data-testid="admin-email"
            type="email"
            placeholder="Correo"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            className="w-full rounded-2xl border-2 border-border bg-white px-4 py-3 font-medium focus:border-primary outline-none"
          />
          <input
            data-testid="admin-password"
            type="password"
            placeholder="Contraseña"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            className="w-full rounded-2xl border-2 border-border bg-white px-4 py-3 font-medium focus:border-primary outline-none"
          />
        </div>
        <motion.button
          data-testid="admin-login-btn"
          whileHover={{ scale: 1.03 }}
          whileTap={{ scale: 0.97 }}
          disabled={loading}
          className="w-full mt-6 flex items-center justify-center gap-2 rounded-full bg-primary py-3.5 font-bold text-primary-foreground shadow-soft disabled:opacity-60"
        >
          {loading ? <CircleNotch className="animate-spin" size={18} /> : "Iniciar sesión"}
        </motion.button>
        <button type="button" onClick={() => navigate("/")} className="w-full mt-4 text-sm font-bold text-foreground/40 hover:text-primary">
          Volver al sitio
        </button>
      </motion.form>
    </div>
  );
}
